import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  // 확인 후 열 셀러센터 주소. 모달이 닫혀 있는 동안은 null 일 수 있다.
  url: string | null;
}

/**
 * 포이즌 셀러센터로 나가기 전 한 번 알리는 모달.
 *
 * 크림은 누구나 보는 공개 상품 페이지라 클릭 즉시 열지만, 포이즌은 판매자 로그인이
 * 필요한 셀러센터의 "입찰 등록" 화면이라 어디로 가는지 모른 채 새 창이 뜨면 놀란다.
 * 새 창을 여는 책임을 여기로 모아 호출부는 "열지 말지"만 정하게 한다.
 */
function PathPickPoizonSellerCenterModal({ isOpen, onClose, url }: Props) {
  const { t } = useI18nHelper();

  const handleConfirm = () => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
    onClose();
  };

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <CustomApprovalModal.Header
        title={t("path_pick:market.poizon_seller_center.title")}
        onClose={onClose}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"8px"}>
          <Text textStyle={"body-md-regular"} color={"#1D1D1B"}>
            {t("path_pick:market.poizon_seller_center.description")}
          </Text>
          <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
            {t("path_pick:market.poizon_seller_center.notice")}
          </Text>
        </Flex>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        cancelName={t("common:cancel")}
        confirmName={t("path_pick:market.poizon_seller_center.confirm")}
        onCancel={onClose}
        onConfirm={handleConfirm}
      />
    </CustomApprovalModal>
  );
}

export default PathPickPoizonSellerCenterModal;
